import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Gem, ShieldCheck } from "lucide-react";
import api, { apiError } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) { toast.error("Passwords do not match"); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success(data.message);
      navigate("/login");
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    setBusy(false);
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#050507] p-6" data-testid="reset-password-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 mb-8 justify-center">
          <div className="w-10 h-10 rounded-xl gold-btn grid place-items-center"><Gem className="w-5 h-5 text-black" /></div>
          <div className="font-display font-extrabold text-lg">Money<span className="gold-text">MoonX</span></div>
        </Link>
        <div className="glass rounded-2xl p-8 border border-amber-500/20">
          <h1 className="font-display text-2xl font-bold">Set a new password</h1>
          {!token ? (
            <p className="text-red-400 mt-4 text-sm">Missing reset token. Please use the link from your email.</p>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <label className="text-sm text-slate-400">New Password</label>
                <input data-testid="reset-password-input" type="password" required minLength={6} value={pw} onChange={(e) => setPw(e.target.value)}
                  className="w-full mt-1.5 bg-[#0D0E12] border border-amber-500/20 focus:border-amber-500 rounded-xl px-4 py-3 outline-none" placeholder="Min 6 characters" />
              </div>
              <div>
                <label className="text-sm text-slate-400">Confirm Password</label>
                <input data-testid="reset-password-confirm-input" type="password" required minLength={6} value={pw2} onChange={(e) => setPw2(e.target.value)}
                  className="w-full mt-1.5 bg-[#0D0E12] border border-amber-500/20 focus:border-amber-500 rounded-xl px-4 py-3 outline-none" placeholder="Re-enter password" />
              </div>
              <button data-testid="reset-password-submit-btn" disabled={busy} className="gold-btn w-full py-3.5 rounded-xl font-bold flex items-center justify-center gap-2 disabled:opacity-60">
                <ShieldCheck className="w-5 h-5" /> {busy ? "Updating..." : "Update password"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
